import { ModuleFE_NLPModel } from './ModuleFE_NLPModel.js';
export const ModulePackFE_NLPModelDB = [ModuleFE_NLPModel];
//# sourceMappingURL=module-pack.js.map